import React from 'react'
import PropTypes from 'prop-types'

import Modal from '../../Modal/Modal'
import Error from '../../Error/Error'
import { ModifiersFooter } from '../ModifiersFooter/ModifiersFooter'

export const ErrorModal = ({ onClose, error, retry }) => (
  <Modal
    footer={<ModifiersFooter isValid={false} />}
    onClose={onClose}>
    <Error error={error} retry={retry} />
  </Modal>
)

ErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  error: PropTypes.object,
  retry: PropTypes.func
}
